// extracted by mini-css-extract-plugin
export default {"button":"TripContainer_button__92c8a","text":"TripContainer_text__XuViU","actionButtons":"TripContainer_actionButtons__RJItL"};